import { useParams } from "react-router";

import { NotFoundPage } from "@/features/not-found";

import { HowToContent } from "./how-to-content";
import { SECTIONS } from "./how-to-data";

/**
 * `/how-to` renders the full single-page guide. `/how-to/:section` is a deep
 * link — the section param is passed through so `HowToContent` smooth-scrolls
 * to that section's anchor on mount. A deep link to an unknown section id is a
 * broken link, so we surface it as 404 rather than silently rendering the
 * guide from the top. Valid ids are derived from `SECTIONS`, so adding a
 * section needs no change here.
 */
export function HowToPage() {
  const { section } = useParams<{ section?: string }>();
  if (section && !SECTIONS.some((s) => s.id === section)) {
    return <NotFoundPage />;
  }
  return <HowToContent section={section} />;
}
